export default function TestimonialSection() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="relative bg-foreground-950 rounded-3xl overflow-hidden">
          <div className="flex flex-col lg:flex-row">
            <div className="lg:w-2/5 relative">
              <div className="w-full h-80 lg:h-full">
                <img
                  src="https://readdy.ai/api/search-image?query=Fashion%20enthusiast%20in%20trendy%20oversized%20blazer%20and%20wide%20leg%20trousers%20sitting%20confidently%20on%20colorful%20painted%20urban%20staircase%2C%20warm%20golden%20hour%20sunset%20light%20creating%20beautiful%20rim%20lighting%20on%20hair%2C%20authentic%20street%20style%20portrait%20photography%2C%20vibrant%20multicultural%20city%20neighborhood%20with%20artistic%20murals%20in%20soft%20bokeh%20background%2C%20genuine%20relaxed%20expression&width=600&height=800&seq=testimonial-v4-portrait&orientation=portrait"
                  alt="Sugargoo Spreadsheet user testimonial"
                  title="Sugargoo Spreadsheet Community Review"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>

            <div className="lg:w-3/5 px-8 md:px-12 lg:px-16 py-12 md:py-16 flex flex-col justify-center">
              <span className="text-accent-400 text-6xl md:text-8xl font-heading leading-none">&ldquo;</span>
              <p className="text-white text-[17px] md:text-[19px] leading-relaxed mt-4 font-medium">
                The Sugargoo Spreadsheet completely changed how I shop. Instead of spending hours searching manually, I now have all the best finds organized in one place. The categorization is incredibly helpful, and the daily updates keep everything fresh. Highly recommended for anyone serious about finding quality products.
              </p>
              <div className="mt-8">
                <p className="text-white font-bold text-[15px]">Alex Chen</p>
                <p className="text-white/50 text-[13px] mt-1 font-medium">Verified Community Member &amp; Spreadsheet Contributor</p>
              </div>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 mt-8 px-6 py-3 bg-accent-500 text-white text-[14px] font-bold rounded-full hover:bg-accent-600 transition-all whitespace-nowrap w-fit cursor-pointer"
              >
                Join Our Community <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}